import { NextRouter } from 'next/router';
import { UrlObject } from 'url';

import { RequestDto } from '@r1-frontend/api-domru/api-request/v1/user/request-by-connection';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';
import { isSomeEnum } from '@r1-frontend/shared/guards/isSomeEnum';
import { EPriceTypes } from '@r1-frontend/shared/types/EPriceTypes';

import { ETariffFilters } from './store/initialState';
import { TProduct } from './store/transformShopItem';
import { ITariffQueryParams } from './types';

export const buildProductsForRequest = (products: TProduct[]) => {
    return products
        .filter(item=> item.quantity > 0)
        .map(product => ({
            id: product.id,
            type: product.category,
            count: product.quantity,
            duration: product.selectedPrice.duration,
        }));
};


/**
 * Подготавливает список оборудования для передачи в запросе на создание договора
 */
export const getEquipmentsListByProps = (equipments: TProduct[]): Omit<RequestDto, 'fio' | 'phone' | 'product_id' | 'csrf'>  => {
    // рассрочка или собственность 1 - покупка, 5 - рассрочка
    let cost_type = EPriceTypes.Possess;
    let leasing_duration;

    const result = equipments.reduce((acc: number[], curr: TProduct) => {
        const { id, quantity, selectedPrice } = curr;

        if (quantity === 0 || !selectedPrice) {
            return acc;
        }

        if (selectedPrice.duration > 0) {
            cost_type = EPriceTypes.Leasing;
            leasing_duration = selectedPrice.duration;
        }

        acc.push(id); // идентификатор оборудования

        return acc;
    }, []);

    return {
        router: result,
        cost_type,
        leasing_duration,
    };
};

// @todo remove and use the useScroll hook (frontend/apps/b2c-domru/src/helpers/hooks/useScroll.ts)
export const scrollBy = (element: HTMLElement, paddingFromTop = 20): void => {
    const domRect = element.getBoundingClientRect();
    const headerHeight = 130;
    const top = domRect.top + window.pageYOffset - headerHeight - paddingFromTop;

    window.scrollTo({
        top,
        behavior: 'smooth',
    });
};

/* Оставляет только значения которые соответствуют перечислению ETariffFilters */
export const returnOnlyEnumValues = (values?: string | string[]): ETariffFilters[] | null => {
    if (!values) {
        return null;
    }

    const isMyEnum = isSomeEnum(ETariffFilters);

    if (Array.isArray(values)) {
        return values.reduce((acc: ETariffFilters[], curr) => {

            if (isMyEnum(curr)) {
                acc.push(curr);
            }

            return acc;
        }, []);
    }

    if (isMyEnum(values)) {
        return [values];
    }

    return null;
};

export const getQueryParams = (params: NextRouter['query']): ITariffQueryParams => {
    if (!params) {
        return {};
    }
    const getStrValue = (value?: string | string[]) => {
        if (!value) {
            return value;
        }

        return typeof value === 'string' ? value : '';
    };

    return {
        salePackageId: getStrValue(params.salePackageId),
        tariffName: getStrValue(params.tariffName),
        monoTariff: getStrValue(params.monoTariff) as 'true' | 'false',
        tariffLine: getStrValue(params.tariffLine),
        filters: returnOnlyEnumValues(params.filters) || undefined,
        landingAvailable: getStrValue(params.landingAvailable),
    };
};

const cleareEmptyFields = <T extends Record<string, any>>(incomingObj: T): Partial<T> => {
    const newObj: Partial<T> = {};

    for (const key in incomingObj) {
        const value = incomingObj[key];
        if (value) {
            newObj[key] = value;
        }
    }

    return newObj;
};

export const getFullBuyRoute = (queryParams: ITariffQueryParams): UrlObject => {
    // Удаляем пустые свойства
    const clearQueryParams = cleareEmptyFields(queryParams);

    return ({
        pathname: '/full-buy',
        query: {
            ...clearQueryParams,
        },
    });
};

/** @deprecated **/
export const sendAnalytics = (action: string, label = ''): void => {
    dataLayerPush({
        event: EVENTS.UAevent,
        category: CATEGORIES.fullBuy,
        action,
        label,
    });
};
